import {useCallback, useEffect, useState} from "react";
import {clearCache, hasCache, hasCacheExpired} from '../../../utils/cacheManager';
import {useMarkerStore} from "../../../store/markerStore";
import useLegendStore from "../../../store/legendStore";
import useMapStore from "../../../store/mapStore";

const useCacheManager = () => {
  const resetMarkerStore = useMarkerStore((state) => state?.setResetMarker);
  const resetLegendStore = useLegendStore((state) => state?.reset);
  const resetMapStore = useMapStore((state) => state.reset)

  const [cacheExists, setCacheExists] = useState<boolean | null>(null);

  const clearCacheFromDb = useCallback(async () => {
    try {
      resetMarkerStore();
      resetLegendStore();
      resetMapStore();

      await clearCache();

      return true;
    } catch (error) {
      console.error('Error clearing marker cache:', error);
      return false;
    }
  }, [resetMarkerStore, resetLegendStore, resetMapStore]);

  useEffect(() => {
    const checkCacheExpiry = async () => {
      const hasExpired = await hasCacheExpired();
      if (hasExpired) {
        await clearCache();
        setCacheExists(false);
      }
    }

    const checkCacheExists = async () => {
      const exists = await hasCache()
      setCacheExists(exists);
    }

    const doChecks = async () => {
      try {
        await checkCacheExpiry();
        await checkCacheExists();
      } catch (error) {
        console.error('Error checking cache status:', error);
        setCacheExists(false);
      }
    }

    doChecks().catch(console.error);
  }, []);

  return {
    clearCache: clearCacheFromDb,
    hasCache: cacheExists
  };
};

export default useCacheManager;
